import { HttpClient } from "@angular/common/http";
import { IResult } from "app/common/interfaces";
import { AbstractService } from "app/services/abstract.service";
import { environment as env } from "../../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import ContactAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/common/embedded/contact/contact.entity";
import { ICreateCompanyContact } from "./interfaces/create-company-contact.interface";
import { IUpdateCompanyContact } from "./interfaces/update-company-contact.interface";
const apiUrl = env.API_CONFIGURATION_URL;
const moduleName = "company_contact";

@Injectable({
  providedIn: "root",
})
export class CompanyContactService extends AbstractService<
ContactAttributes,
ICreateCompanyContact,
IUpdateCompanyContact
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findByCompanyId(companyId: string): Observable<IResult<ContactAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${companyId}`;
    return this.http.get<IResult<ContactAttributes>>(API_URL);
  }
}